import React, { useEffect, useState } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ComparativeAccount, ButtonLoading, InputV2 } from 'components';
import comparativeAccountServices from 'components/ComparativeAccount/services/ComparativeAccountServices';
import { useStyles } from './style';
// import { createAccount } from '../../../../../services/DetailAccountsServices';
import createToast from 'components/Toast/Toast';

const CreateDetailAccounts = (props) => {
  const { onSubmitEnd } = props;
  const classes = useStyles();
  const { control, handleSubmit, formState: { errors }, register, watch, setValue } = useForm();

  const comparativeAccountWatch = watch('comparativeAccount');

  useEffect(() => {
    if (comparativeAccountWatch?.name) setValue('aliasName', comparativeAccountWatch?.name);
  }, [comparativeAccountWatch, setValue]);

  const [comparativeAccountList, setComparativeAccountList] = useState({
    list: [],
    selectedList: [],
  });
  const [, setOpenSnack] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const result = await comparativeAccountServices.getList();
        const { data } = result;
        setComparativeAccountList({
          list: data.result.guilds,
          selectedList: data.result.businessGuilds,
        });
      } catch (error) {}
    })();
  }, []);

  const onSubmit = (data) => {
    setLoadBtn(true);

    let dataApi = {};

    if (data?.comparativeAccount?.code) {
      dataApi.guildCode = data.comparativeAccount.code;
    }

    if (data?.aliasName) {
      if (data.aliasName.length > 0) {
        dataApi = { ...dataApi, aliasName: data.aliasName };
      }
    }

    if (!dataApi?.aliasName && !dataApi?.guildCode) {
      if (!dataApi?.aliasName) {
        createToast('خطا', 'ابتدا حساب مورد نظر را انتخاب کنید', 'danger');
      } else {
        createToast('خطا', 'ابتدا عنوان حساب را وارد کنید', 'danger');
      }
      setLoadBtn(false);
      return;
    }
    async function creatAccount(params) {
      try {
        // await createAccount(params);
        createToast('موفق', 'ایجاد حساب با موفقیت انجام شد.', 'success');
        setOpenSnack(true);
      } catch (error) {
        if (onSubmitEnd) onSubmitEnd(error?.response?.data?.message?.fa, 'danger');
        setOpenSnack(true);
        return;
      }

      setLoadBtn(false);
    }
    creatAccount(dataApi);
  };

  const hint = 'در این بخش می‌توانید حساب کسب‌و‌کاری جدید تعریف کنید.';

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography className={classes.hint}>{hint}</Typography>
          </Grid>

          <Grid item xs={12}>
            <ComparativeAccount
              errors={errors}
              control={control}
              name="comparativeAccount"
              register={register}
              selectedList={comparativeAccountList.selectedList}
              list={comparativeAccountList.list}
              style={{ marginBottom: 8 }}
            />

            {comparativeAccountWatch && (
              <InputV2
                fullWidth
                className={classes.alias}
                errors={errors}
                label="ویرایش نام حساب"
                name="aliasName"
                register={register}
                control={control}
              />
            )}
          </Grid>

          <Grid item xs={12} className={classes.cardActions}>
            <ButtonLoading
              type="submit"
              color="primary"
              variant="contained"
              className={classes.button}
              loading={loadBtn}
              name="ایجاد حساب"
            />
            <Button
              variant="contained"
              onClick={() => onSubmitEnd()}
              style={{ marginInlineStart: 10 }}
            >
              انصراف
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default CreateDetailAccounts;
